import {Directive, ViewContainerRef} from "@angular/core";

@Directive({
  selector: '[alpha-filters]'
})
export default class FilterDirective {
  constructor(public readonly viewContainerRef: ViewContainerRef) {}
}
